import {
  acceptOnlyFilterdKeys,
  arrangeFiltersByOrder,
  basePathRewrite,
  cetgoriesCount,
  commonPropsForSSR,
  freeJobsExperiment,
  getEBendPoints,
  getEJendPoints,
  getFreeJobViewQuota,
  getJobIndex,
  getRmcCategories,
  getSavedSearchIdData,
  getURLSearchParams,
  handeActiveFilter,
  modifyJobFilters,
  modifyQueryLocation,
  modifySelectedLocation,
  readCookie,
  readFeatureCookieByKey,
  setFeatureCookieByKey,
  titleValue,
} from '@components/common';
import companiesMapping from '@components/common/companiesMapping.json';
import { _CONSTANTS, ApplyJobStatus } from '@components/common/constant';
import {
  addJobsCountTraits,
  jobSearchResultTrackEvent,
  jobTableTrackImpressionsEvent,
} from '@components/common/event-tracker';
import {
  getFilterQueryString,
  mapQueryParams,
} from '@components/common/filterHelper';
import { jobsCategory } from '@components/common/jobCategoryHelper';
import { RemoteCategoriesMetaTags } from '@components/metaComponent/remoteCategories';
import SearchListingContainer from '@components/searchListContainer';
import { JobLinks, socialLinks } from '@components/wlb/constant';
import { JobSearchSteps, JobsList } from '@license-admin/boldjobs';
import { width } from '@styles/device.styled';
import { fireExperimentEvent } from '@utils/cdnTracking';
import jobSearchStepsProps from '@utils/jobSearchStepsProps';
import { processFreeJobDetailsCategory } from '@utils/showDetails';
import softRegModalProps from '@utils/softRegModalProps';
import useMediaQuery from '@utils/useMediaQuery';
import { applyJob, getJobDetails, logErrorServer } from 'API/ApiHelpers';
import {
  getLocalizationAndConfig,
  jobViewed,
  modifyJobDetails,
} from 'API/jobs';
import { apiCallList } from 'API/wlb/ApiClient';
import { getFreeRemoteJobsByCategory } from 'API/wlb/jobs';
import { getENVPath } from 'helper';
import {
  getGuidValue,
  getSearchType,
  isQueryEmpty,
} from 'helper/eventTrackingUtils';
import {
  Action,
  ClickOption,
  SearchType,
  TrackingEvents,
  USER_TRAITS_JOBS_COUNT,
  ViewType,
} from 'helper/eventTrackingUtils/constant';
import {
  getBackendVisiterExpDetail,
  getCDNExptDetails,
  getExperimentVariant,
} from 'helper/experiments/experimentActions';
import { RMCPortalExperiments } from 'helper/experiments/experimentConstants';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useCallback, useEffect, useMemo, useState } from 'react';
const ReactPaginate = dynamic(() => import('react-paginate'), { ssr: false });

const CategoryPage = (props: any) => {
  const {
    themeType,
    selectedLocation,
    searchKeyword,
    saveSearchButtonState,
    queryParams,
    jobCardData,
    localization,
    deviceType,
    config,
    isPremiumUser,
    selectedFilters,
    isLoggedIn,
    categoryDetails,
    isFromWizardPage,
    showAllDropFilters,
    userAgent,
    isSecondaryModalPopup,
    cdnExptData,
    userInteractionJobId,
    jobs_details_by_id,
    useInteractionVariant,
    selectedCountry,
    countryList,
    hiring_count,
    pageTitle,
    useCanonicalTwo,
    isQueryParamsEmpty,
    freeJobsByCategory,
    setGuid,
    enableFreeJobsView,
  } = props;

  const router = useRouter();
  const getRmcCategoriesEXPdata = {
    ...jobs_details_by_id,
    getRmcCategories,
  };
  const [jobDetails, setJobDetails] = useState<any>(
    getRmcCategoriesEXPdata || {}
  );
  console.log(userInteractionJobId, 'userInteractionJobId in category page');
  const [isAddStaticSearchList, setAddStaticSearchList] = useState(false);
  const [activeJobId, setActiveJobId] = useState(userInteractionJobId || null);
  const [savedJobsArray, setSavedJobsArray] = useState<number[]>([]);

  const isMobileView = useMediaQuery(width.tabletSm) || deviceType === 'mobile';

  const queryParamsByOrder = useMemo(
    () => arrangeFiltersByOrder(queryParams),
    [queryParams]
  );

  const breadCrumbProps = useMemo(
    () => ({
      breadCrumbName: isPremiumUser
        ? 'category-rc-premium'
        : 'category-rc-public',
      breadCrumbNameValue: [''],
      breadCrumbsData: [
        {
          page: 'category-rc-premium',
          title: 'Remote Jobs - No Ads, Scams, or Junk',
          children: [
            {
              name: 'My Dashboard',
              path: basePathRewrite('/dashboard'),
              static: false,
            },
            {
              name: 'Remote Jobs',
              path: basePathRewrite('/remote-jobs'),
              static: false,
            },
            {
              name: `Remote ${titleValue(pageTitle)} Jobs - Work From Home`,
              path: '',
              static: true,
            },
          ],
        },
        {
          page: 'category-rc-public',
          title: 'Remote Jobs - No Ads, Scams, or Junk',
          children: [
            { name: 'Home', path: basePathRewrite('/'), static: false },
            {
              name: 'Remote Jobs',
              path: basePathRewrite('/remote-jobs'),
              static: false,
            },
            {
              name: `Remote ${titleValue(pageTitle)} Jobs - Work From Home`,
              path: '',
              static: true,
            },
          ],
        },
      ],
    }),
    [isPremiumUser, pageTitle]
  );

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const conductExperiment = async () => {
      const visitorId = readCookie(_CONSTANTS.VSTR);
      if (visitorId) {
        const experimentData = await getBackendVisiterExpDetail(
          deviceType,
          {
            mobile: RMCPortalExperiments.rmcFreeJobsV2Mobile,
            desktop: RMCPortalExperiments.rmcFreeJobsV2Desktop,
          },
          userAgent
        );
      } else {
        timeoutId = setTimeout(conductExperiment, 500);
      }
    };
    timeoutId = setTimeout(conductExperiment, 500);
    return () => clearTimeout(timeoutId);
  }, [deviceType, userAgent]);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const conductExperiment = async () => {
      const visitorId = readCookie(_CONSTANTS.VSTR);
      if (visitorId) {
        const experimentData = await getBackendVisiterExpDetail(
          deviceType,
          {
            mobile: RMCPortalExperiments.rmcLocationFieldMobile,
            desktop: RMCPortalExperiments.rmcLocationFieldDesktop,
          },
          userAgent
        );
        if (experimentData?.variant && experimentData?.variant > 2) {
          setAddStaticSearchList(true);
        }
      } else {
        timeoutId = setTimeout(conductExperiment, 500);
      }
    };
    timeoutId = setTimeout(conductExperiment, 500);
    return () => clearTimeout(timeoutId);
  }, [deviceType, userAgent]);

  const updateSaveJobState = useCallback((jobId: number, status: boolean) => {
    setSavedJobsArray((prev) =>
      status
        ? prev.includes(jobId)
          ? prev
          : [...prev, jobId]
        : prev.filter((id) => id !== jobId)
    );
  }, []);

  const saveJobState = useMemo(
    () => ({
      savedJobsArray,
      updateSaveJobState,
    }),
    [savedJobsArray, updateSaveJobState]
  );

  const searchForm = (
    <SearchListingContainer
      localization={localization}
      saveSeachButtonState={saveSearchButtonState}
      showAllDropFilters={showAllDropFilters}
      deviceType={deviceType}
      categoryDetails={categoryDetails}
      isPremiumUser={isPremiumUser}
      jobsData={jobCardData}
      queryParams={queryParams}
      jobFilters={jobCardData.jobFilters}
      selectedFilters={selectedFilters}
      location={selectedLocation}
      searchedJobTitle={searchKeyword}
      isBasealign={isMobileView && isLoggedIn && !isPremiumUser}
      isSearchPage={false}
      isRemoteJobsPage={true}
      selectedCountry={selectedCountry}
      countyList={countryList}
      isAddStaticSearchList={isAddStaticSearchList}
      envPath={getENVPath().NEXT_PUBLIC_ROOT_URL}
    />
  );

  const mergedQueries = useMemo(
    () => ({
      ...queryParamsByOrder,
      ...router.query,
      joblocations: selectedLocation,
    }),
    [queryParamsByOrder, router.query, selectedLocation]
  );

  const jobsData = useMemo(
    () => ({
      ...jobCardData,
      mergedQueries,
    }),
    [jobCardData, mergedQueries]
  );

  const fetchJobData = useCallback(
    async (jobID: string) => {
      if (!jobID) throw new Error('Job ID is required for tracking.');
      const jobDetailResp = await getJobDetails(jobID);
      const jobDetails = jobDetailResp?.data;
      if (!jobDetails) throw new Error(`No job details found for ID: ${jobID}`);
      const jobIndex = getJobIndex(jobCardData.jobs.results, jobID);
      const guid = getGuidValue(setGuid);
      return { jobDetails, jobIndex, guid };
    },
    [jobCardData.jobs.results, setGuid]
  );

  const determineAccessStatus = useCallback(
    (jobDetails: any) => {
      if (isLoggedIn) {
        return isPremiumUser ? SearchType.Unlocked : SearchType.Locked;
      }
      return jobDetails?.isFreeJob ? SearchType.Unlocked : SearchType.Locked;
    },
    [isLoggedIn, isPremiumUser]
  );

  const trackJobSearchResult = useCallback(
    async (action: string, jobID?: string, clickOption?: string) => {
      const { jobDetails, jobIndex, guid } = await fetchJobData(jobID!);
      const accessStatus = determineAccessStatus(jobDetails);
      const mergerdQueries = { ...queryParams, ...router.query };
      return jobSearchResultTrackEvent(
        action,
        getSearchType(),
        ViewType.Job_Post_Details,
        accessStatus,
        jobDetails,
        jobCardData,
        mergerdQueries,
        clickOption,
        jobIndex,
        guid
      );
    },
    [
      fetchJobData,
      determineAccessStatus,
      queryParams,
      router.query,
      jobCardData,
    ]
  );

  const hideDetails = useCallback(() => {
    setActiveJobId(null);
    setJobDetails({});
  }, []);

  const handleApplyJob = useCallback(() => {
    addJobsCountTraits(USER_TRAITS_JOBS_COUNT.JOB_APPLICATIONS);
    applyJob(activeJobId, ApplyJobStatus.applied);
    trackJobSearchResult(Action.Applied, activeJobId);
  }, [activeJobId, trackJobSearchResult]);

  const trackJobSearchImpression = async (action: string, jobID?: string) => {
    const { jobDetails, jobIndex, guid } = await fetchJobData(jobID!);
    const mergerdQueries = {
      ...props?.queryParams,
      ...router.query,
    };
    return jobTableTrackImpressionsEvent(
      action,
      getSearchType(),
      TrackingEvents.Job_Search_Result,
      jobDetails,
      jobCardData,
      mergerdQueries,
      null,
      jobIndex,
      guid
    );
  };

  const showDetails = async (e: any, jobID: string) => {
    try {
      let jobDetailResp = await getJobDetails(jobID);

      jobDetailResp = processFreeJobDetailsCategory(
        jobDetailResp,
        jobID,
        deviceType,
        categoryDetails,
        isPremiumUser
      );

      let isrmcwpJob = false;
      if (jobDetailResp.data && jobDetailResp.data.company) {
        const companyMapping = companiesMapping.find(
          (company) => company.rmc === jobDetailResp.data.company.slug
        );
        if (!companyMapping) {
          isrmcwpJob = true;
          jobDetailResp.data.isrmcwpJob = true;
        }
      }
      const getRmcCategoriesData = { getRmcCategories };
      if (enableFreeJobsView && !isPremiumUser) {
        const { allowViewFreeJob, viewedJobIds } = await getFreeJobViewQuota(
          categoryDetails.id
        );
        // Find the category key and job object for the given jobID
        const foundValue = freeJobsByCategory.value.find(
          (item: any) => item.id === jobID
        );
        const foundKey = freeJobsByCategory?.key;
        // foundValue is the job object with the matching jobID

        if (foundValue && isrmcwpJob) {
          foundValue.isrmcwpJob = true;
        }

        // If user has exhausted free job views
        if (!allowViewFreeJob && foundValue) {
          // viewedJobIds is an object like { 1: ['123', '456'], 4: ['222', '555'] }
          // Flatten all viewed job IDs and check if jobID is present
          const allViewed = Object.values(viewedJobIds || {}).flat();
          const hasViewed = allViewed.includes(jobID);

          setActiveJobId(jobID);
          if (hasViewed) {
            setJobDetails({ ...foundValue, ...getRmcCategoriesData });
          } else {
            setJobDetails({
              ...jobDetailResp.data,
              isFreeJob: false,
              description: null,
              ...getRmcCategoriesData,
            });
          }
          return;
        }

        // If allowed to view, update cookie if needed
        if (allowViewFreeJob && foundKey && foundValue) {
          let freeJobsObj: Record<string, string[]> = {};
          try {
            const cookieVal =
              readFeatureCookieByKey('experimentBasedFreeRemoteJobs') || '';
            if (typeof cookieVal === 'string' && cookieVal !== '') {
              freeJobsObj = JSON.parse(cookieVal);
            } else if (typeof cookieVal === 'object' && cookieVal !== null) {
              freeJobsObj = cookieVal;
            }
          } catch {
            freeJobsObj = {};
          }
          const catId = String(foundKey);
          freeJobsObj[catId] = freeJobsObj[catId] || [];
          if (!freeJobsObj[catId].includes(jobID)) {
            freeJobsObj[catId].push(jobID);
          }

          // ! Set Value
          if (foundValue) {
            jobDetailResp.data = foundValue;
          }

          setFeatureCookieByKey({
            key: 'experimentBasedFreeRemoteJobs',
            value: JSON.stringify(freeJobsObj),
          });
        }
      }

      if (isLoggedIn && jobID) {
        addJobsCountTraits(USER_TRAITS_JOBS_COUNT.VIEWED_JOBS);
        jobViewed(jobID);
      }

      setActiveJobId(jobID);
      setJobDetails({
        ...jobDetailResp.data,
        ...getRmcCategoriesData,
      });
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      logErrorServer(
        `FXJ RMC_JOBS Client error: Status Code: ${errorMessage}`,
        `Failed to fetch data from Function: showDetails function : ${errorMessage}`,
        true
      );
    }
  };

  const softRegProps = softRegModalProps({
    config,
    jobCardData,
    isFromWizardPage,
    isMobileView: props.deviceType === 'mobile',
    hiring_count: props.hiring_count,
    isExperiment: isMobileView
      ? true
      : cdnExptData?.vID == '3' && !props.isPremiumUser,
  });
  const categoryTitle = `Remote ${titleValue(
    props?.pageTitle
  )} Jobs - Work From Home`;

  useEffect(() => {
    if (useInteractionVariant === 3) {
      const intervalId = setInterval(() => {
        // Remove the 'openJobFromCategory' cookie by setting its expiry date to the past
        document.cookie = `openJobFromCategory=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
        clearInterval(intervalId);
      }, 3000);
    }
  }, []);

  const jobSearchStepsProp = useMemo(
    () =>
      jobSearchStepsProps({
        isCloseAllowed: true,
        isLoggedIn,
        themeType,
        isCategoryPage: true,
        signupAndFind: localization.unlock_banner.signup_and_find,
        jobsData: jobCardData,
        categoryDetails,
        hiringCount: hiring_count,
        localization,
        screenName: 'jobs by category',
      }),
    [
      isLoggedIn,
      themeType,
      localization,
      jobCardData,
      categoryDetails,
      hiring_count,
    ]
  );

  const isInteractionVariantActive =
    useInteractionVariant === 3 || useInteractionVariant === 4;
  // Add this near the other useEffect hooks in your CategoryPage component

  return (
    <>
      <Head>
        {RemoteCategoriesMetaTags({
          categoryName: categoryDetails?.slug || '',
          canonicalTwo: useCanonicalTwo,
          isQueryParamsEmpty,
        })}
      </Head>
      <Script
        src="/ui-experimentation/cdn/experiment-sync.min.js"
        strategy="afterInteractive"
      />
      <Script id="experiment-script" strategy="afterInteractive">
        {`
          window.fireExperimentEvent = ${fireExperimentEvent.toString()};
        `}
      </Script>
      <JobSearchSteps jobSearchStepsProps={jobSearchStepsProp} />
      <JobsList
        isSoftRegModal={!isLoggedIn}
        softRegModalProps={softRegProps}
        breadCrumbProps={breadCrumbProps}
        showDetails={showDetails}
        hideDetails={hideDetails}
        handleApplyJob={handleApplyJob}
        jobDetails={jobDetails}
        isCategoryDetails={true}
        isSearchScreen={false}
        jobDescriptionPara={categoryDetails?.categoryOverview || ''}
        searchedJobTitle={categoryTitle}
        jobId={activeJobId}
        isPremiumUser={isPremiumUser}
        isLoggedIn={isLoggedIn}
        pageHeading={categoryTitle}
        deviceType={deviceType}
        themeType={themeType}
        categoryData={jobCardData.jobs.results}
        jobLinks={JobLinks}
        socialLinks={socialLinks}
        searchForm={searchForm}
        pageCount={jobCardData?.jobs?.totalPages}
        localization={localization}
        isSecondaryModalPopup={isSecondaryModalPopup}
        filterProps={{
          type: router?.query?.sortbyposteddate ? 'date' : 'relevance',
          changeFilter: (filterType: ClickOption) => {
            handeActiveFilter(filterType, router);
          },
        }}
        isNoSearchResult={jobCardData?.jobs.resultPerPage < 1}
        saveJobState={saveJobState}
        isBasealign={isMobileView && !isPremiumUser}
        basePathRewrite={basePathRewrite}
        trackJobSearchResult={trackJobSearchResult}
        trackJobSearchImpression={trackJobSearchImpression}
        jobCardData={jobsData}
        cetgoriesCount={cetgoriesCount}
        hiring_count={hiring_count}
        ReactPaginate={ReactPaginate}
        useInteractionVariant={isInteractionVariantActive}
      />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req, query, resolvedUrl, res } = context;
  // Handle canonical issue for 'remote-jobs/international' page
  const useCanonicalTwo = resolvedUrl?.includes('useCanonicalTwo');

  const category = (query.category as string)?.toLowerCase();
  if (!category) {
    return { notFound: true };
  }

  // Redirect if category is not lowercase
  if ((query.category as string) !== category) {
    return {
      redirect: {
        destination: `/remote-jobs/${encodeURIComponent(category)}`,
        permanent: false,
      },
    };
  }

  // Prepare filters and SSR props
  const filterValues = acceptOnlyFilterdKeys(query);
  const preSelectedFilters = { categories: [category] };
  let commonSSRProps = await commonPropsForSSR(
    req,
    'new_jobs',
    preSelectedFilters
  );
  const { cookieHeader, isPremiumUser, deviceType } = commonSSRProps;
  let enableFreeJobsView = !isPremiumUser
    ? getENVPath().NEXT_FEATURE_FLAG_FREE_JOBS_VIEW
    : false;

  let selectedFilters = acceptOnlyFilterdKeys(query);
  let mappedQuery = mapQueryParams(query);
  let queryString = getFilterQueryString(mappedQuery);
  let selectedLocation = getURLSearchParams(mappedQuery, 'joblocations');
  let pageNumber: string = getURLSearchParams(query, 'page');

  // Fetch category details and update SSR props
  const jobsCategoryResult = await jobsCategory(
    category,
    commonSSRProps,
    filterValues,
    mappedQuery,
    queryString
  );
  const categoryDetails = jobsCategoryResult?.categoryDetails || {};
  commonSSRProps = jobsCategoryResult.commonSSRProps;
  queryString = jobsCategoryResult.queryString;
  mappedQuery = jobsCategoryResult.query;

  if (!['1', '4'].includes(String(categoryDetails.id)) && enableFreeJobsView) {
    enableFreeJobsView = false;
  }

  // Setup experiment variant
  const userInteractExpId =
    deviceType === 'mobile'
      ? RMCPortalExperiments.rmcUserInteractionMobile.id
      : RMCPortalExperiments.rmcUserInteractionDesktop.id;
  const expData = await getExperimentVariant(userInteractExpId, cookieHeader);

  // Prepare API endpoints
  const ejEndPoints = getEJendPoints();
  const ebEndPoints = getEBendPoints();
  const apiEndpoints: any = {
    job_details: {
      ...ejEndPoints.job_details,
      callback: modifyJobFilters,
    },
    hiring_count: ejEndPoints.hiring_count,
  };
  if (selectedLocation) {
    apiEndpoints.country_list = ebEndPoints.country_list;
  }

  // Modify job details endpoint for SSR
  modifyJobDetails(
    apiEndpoints.job_details,
    `search/${queryString.slice(0, -1)}`,
    {
      SortByPostedDate: true,
      jobStatus: true,
      cp: enableFreeJobsView ? false : true,
    },
    false
  );

  // Fetch data from APIs
  const data = await apiCallList({ apiEndpoints, cookieHeader, req });
  const {
    job_details,
    country_list = [],
    hiring_count = { jobsCount: 0, companiesCount: 0 },
  } = data;

  // Process job data
  let result = apiEndpoints.job_details.callback(
    mappedQuery,
    job_details,
    isPremiumUser
  );
  mappedQuery = result.query;
  let jobCardData = result.jobCardData;
  let countryList = country_list;

  // ! Code for SEO Trail free Jobs Gating on the basis of cookie
  let freeJobsByCategory = [];
  if ((pageNumber == '' || pageNumber != '1') && enableFreeJobsView) {
    // Fetch free jobs by category and find the one matching the current categoryDetails.id
    const freeJobsByCategoryList = await getFreeRemoteJobsByCategory(
      ['1', '4'],
      cookieHeader
    );
    freeJobsByCategory = freeJobsByCategoryList.find(
      (item: any) => String(item.key) === String(categoryDetails.id)
    ) || { key: categoryDetails.id, value: [] };
    if (
      Array.isArray(freeJobsByCategory.value) &&
      freeJobsByCategory.value.length > 0
    ) {
      const slicedResults = (jobCardData.jobs.results || []).slice(8);
      jobCardData.jobs.results = [
        ...freeJobsByCategory.value,
        ...slicedResults,
      ];
    }
  }

  if (jobCardData?.jobs.resultPerPage < 1 && Number(pageNumber)) {
    return {
      notFound: true,
    };
  }

  // Handle selected location
  let countryName = '';
  if (selectedLocation) {
    const { locationObj, isInternationalLocation, locationNameAndState } =
      modifySelectedLocation(selectedLocation, countryList);
    selectedLocation = locationNameAndState;
    countryName = locationObj.countryName;
    mappedQuery = modifyQueryLocation(
      locationObj,
      isInternationalLocation,
      mappedQuery
    );
  }

  // If category is invalid, return 404
  if (!categoryDetails.categoryTitle) {
    return { notFound: true };
  }

  // Get saved search props
  const savedSearchProps = await getSavedSearchIdData(
    req,
    mappedQuery,
    cookieHeader,
    queryString,
    deviceType,
    selectedFilters
  );

  // Get signup localization if not premium
  const signupLocalization =
    (!isPremiumUser && (await getLocalizationAndConfig('signup'))) || [];

  // Handle experiment variants for job details
  let jobs_details_by_id = {};
  let userInteractionJobId = null;

  const cdnLpExperiment =
    readCookie(_CONSTANTS.EW_EXP, cookieHeader)?.split('_')?.[0] || '';

  const lpExperimentId = [
    'eae4ec89-c898-4f99-b8a4-ad1c607624d8',
    '75225d54-5c32-4b6b-a569-ce0bb61b3f39',
  ];

  if (expData == 3 || lpExperimentId.includes(cdnLpExperiment)) {
    userInteractionJobId =
      readCookie('openJobFromCategory', cookieHeader) || '';
    if (userInteractionJobId) {
      const jobById = await getJobDetails(userInteractionJobId);
      jobs_details_by_id = jobById?.data || {};
    }
  } else if (expData == 4) {
    userInteractionJobId = jobCardData?.jobs?.results[0]?.id || '';
    if (userInteractionJobId) {
      const jobById = await getJobDetails(userInteractionJobId);
      jobs_details_by_id = jobById?.data || {};
    }
  }

  // Check if query params are empty
  const isQueryParamsEmpty = isQueryEmpty(resolvedUrl);

  // Run free jobs experiment
  const jobResults = await freeJobsExperiment(
    jobCardData?.jobs?.results || [],
    req.headers.cookie,
    commonSSRProps.deviceType,
    res,
    commonSSRProps.isPremiumUser
  );
  let jobsList = {
    ...jobCardData,
    jobs: { ...jobCardData.jobs, results: jobResults },
  };

  let freeJobViewQuota = await getFreeJobViewQuota(
    categoryDetails.id,
    commonSSRProps?.cookieHeader || req.headers.cookie
  );

  // Prepare CDN experiment data
  const cdnExptData = getCDNExptDetails(
    mappedQuery,
    commonSSRProps.deviceType,
    commonSSRProps?.cookieHeader
  );

  return {
    props: {
      ...commonSSRProps,
      ...savedSearchProps,
      freeJobViewQuota,
      jobCardData: jobsList,
      freeJobsByCategory,
      enableFreeJobsView,
      selectedFilters: commonSSRProps.selectedFilters,
      hiring_count,
      selectedLocation,
      selectedCountry: countryName || '',
      categoryDetails: categoryDetails || {},
      countryList,
      headerProps: ['/remote-jobs', ''],
      queryParams: mappedQuery,
      jobs_details_by_id: jobs_details_by_id || {},
      userInteractionJobId,
      signupLocalization,
      useInteractionVariant: expData || 0,
      isSecondaryModalPopup: true,
      isCategoryJobsPage: true,
      showAllDropFilters: true,
      pageTitle: categoryDetails?.categoryTitle || '',
      fullwidth: true,
      useCanonicalTwo: useCanonicalTwo || false,
      userAgent: req?.headers['user-agent'] ?? '',
      isQueryParamsEmpty,
      cdnExptData,
    },
  };
};

export default CategoryPage;
